<template>
  <div>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <el-button type='primary' icon='sys sys-print' class='navbarbtn' v-if='showPrintPower'
        @click='printPOOrder'>
        打 印
      </el-button>

      <el-button type='primary' icon='sys sys-commit' class='navbarbtn' v-if='showCommitDocumentPower'
        @click='commitPPO'>
        提 交
      </el-button>

      <el-button type='danger' icon='sys sys-cancelcommit' class='navbarbtn' v-if='showCancelCommitDocumentPower'
        @click='cancelCommitPPO'>
        撤销提交
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.itemNumber' style='width: 125px;' placeholder='物料代码'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.itemName' style='width: 125px;' placeholder='物料名称'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :reduceHeight='200' :seqFixed='true'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='true' operationColumnWidth='170px'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      :expandRowKeys='mainTable.expandRowKeys'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='操作日志' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='showPOOrderLogDialogMD(scope)'><i class='sys sys-log'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='材料明细' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='showPOOrderDocumentDialogMD(scope.data.row)'><i class='sys sys-file'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='回复交期' placement='top-start'
          v-if='showReplyDevDatePower && scope.data.row.DocumentCommitStatus === "0"'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='showReplyDevDateDialogMD(scope)'><i class='wms wms-devdate'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='上传材料' placement='top-start'
          v-if='showUploadDocumentPower && scope.data.row.DocumentCommitStatus === "0"'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='showUploadDocumentDialogMD(scope)'><i class='sys sys-uploaddocument'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='撤销提交' placement='top-start'
          v-if='showHandleRejectPower && scope.data.row.DocumentCommitStatus === "2"'>
          <el-button type='danger' circle style='padding: 4px;'
            @click='handleRejectPPO(scope.data.row)'><i class='sys sys-cancelcommit'></i>
          </el-button>
        </el-tooltip>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>料号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 350px; text-align: left;'><span style='color: #42426F;'>名称</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>含税单价</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>价税合计</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>税率</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 90px; text-align: left;'><span style='color: #42426F;'>交期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 90px; text-align: left;'><span style='color: #42426F;'>回复交期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>生成标签</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>到货</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>入库</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>退货</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>规格</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='ppoe in scope.data.row.detailDt1' :style='mainTableDetail1RowStyle(scope.data.row, ppoe)'
            :key='ppoe.EntryID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{ppoe.EntryID}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: blue;'>{{ppoe.ItemNumber}} </span></div>
            <div class='expand-row' style='min-width: 350px; text-align: left;'><span style='color: blue;'>{{ppoe.ItemName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.Qty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.AuxTaxPrice}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{typeof (ppoe.AllAmount) === 'number' ? ppoe.AllAmount.toFixed(2) : ''}} </span></div>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{ppoe.Cess}}% </span></div>
            <div class='expand-row' style='min-width: 90px; text-align: left;'><span style='color: blue;'>{{ppoe.DevDate.substring(0, 10)}} </span></div>
            <div class='expand-row' style='min-width: 90px; text-align: left;'><span style='color: blue;'>{{ppoe.NewDevDate ? ppoe.NewDevDate.substring(0, 10) : ''}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{ppoe.CreateQRCodeQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.CommitQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.StockQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.ReturnQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: blue;'>{{ppoe.ItemModel}} </span></div>
          </div>
        </div>
      </template>
    </Table>

    <!-- 选择文件弹出框 -->
    <el-dialog v-dialogDrag :visible.sync='showUploadDocumentDialog' title='选择材料'
      width='400px' top='10px' lock-scroll append-to-body>
      <el-upload action='' style='margin-top: -35px;'
        :before-upload='uploadDocumentFile'
        drag :multiple='false' :show-file-list='false'>
        <i class='el-icon-upload'></i>
        <div class='el-upload__text'>将文件拖到此处，或<em>点击上传</em></div>
        <div class='el-upload__tip'>文件大小不能超过10M</div>
      </el-upload>
      <div style='text-align: center;'>
        <a :href='uploadTempFileUrl' target='_blank'>{{uploadTempFileName}}</a>
      </div>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='uploadDocument()' size='mini'>上传材料</el-button>
        <el-button @click='showUploadDocumentDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag title='操作日志' :visible.sync='showPOOrderLogDialog' width='920px'
      top='10px' lock-scroll>
      <el-table :data='POOrderLog' border height='300px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='LogNo' label='记录号' width='160'>
        </el-table-column>
        <el-table-column prop='Content' label='操作内容' width='400'>
        </el-table-column>
        <el-table-column prop='CreateTime' label='操作时间' width='160'>
          <template #default='scope'>
            {{dateTimeUtil.formartDateTime(new Date(scope.row.CreateTime), 'yyyy-MM-dd HH:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column prop='CreateUserName' label='操作人' width='100'>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog v-dialogDrag title='回复交期' :visible.sync='showReplyDevDateDialog' width='920px'
      top='10px' lock-scroll>
      <el-table :data='replyDevDateRows' border :height='getCreateReplyDevDateTableHeight()'
        :cell-style='replyDevDateTableCellStyle' :header-cell-style='replyDevDateTableHeaderCellStyle'
        style='margin-top: -35px;' row-key='GUID' size='medium' ref='replyDevDateTable'>
        <el-table-column prop='EntryID' label='行号' width='60'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='350'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='80'>
        </el-table-column>
        <el-table-column prop='DevDate' label='交期' width='100'>
          <template #default='scope'>
            <span>{{scope.row.DevDate.substring(0, 10)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop='NewDevDate' label='回复交期' width='120'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.NewDevDate'
              @change='replyDevDateTableNewDevDateChange(scope.row)'
              style='width: 100px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='UnitName' label='单位' width='60'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='350'>
        </el-table-column>
        <el-table-column prop='SupplyName' label='供应商' width='250'>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='saveNewDevDate()' size='mini'>提交</el-button>
        <el-button @click='showReplyDevDateDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag title='材料明细' :visible.sync='showPOOrderDocumentDialog' width='730px'
      top='10px' lock-scroll>
      <el-table :data='POOrderDocument' border height='250px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='DocumentName' label='材料名称' width='400'>
          <template #default='scope'>
            <a target='_blank' :href='scope.row.FilePath'>{{scope.row.DocumentName}}</a>
          </template>
        </el-table-column>
        <el-table-column prop='CreateTime' label='操作时间' width='160'>
          <template #default='scope'>
            {{dateTimeUtil.formartDateTime(new Date(scope.row.CreateTime), 'yyyy-MM-dd HH:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column label='操作' width='60'>
          <template #default='scope'>
            <el-tooltip effect='dark' content='删除材料' placement='top-start'
              v-if='showUploadDocumentPower'>
              <el-button type='danger' circle style='padding: 4px;'
                @click='deleteDocument(scope.row)'><i class='sys sys-delete'></i>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import power from '@/components/sys/Power'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'
import axios from 'axios'

export default {
  name: 'POrderUploadDocument',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'PO_POOrder_2',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        customFilterStr: ' AND 1=0 ',
        Loading: false,

        detail1FilterStr: '',
        itemNumber: '',
        itemName: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      dateTimeUtil: dateTimeUtil,

      showUploadDocumentDialog: false,
      uploadPPO: {},
      uploadTempFileUrl: '',
      uploadTempFileName: '',

      showPOOrderLogDialog: false,
      POOrderLog: [],

      showReplyDevDateDialog: false,
      replyDevDateRows: [],
      replyDevDatePPo: {},

      showPOOrderDocumentDialog: false,
      POOrderDocument: [],

      showPrintPower: false,
      showUploadDocumentPower: false,
      showCommitDocumentPower: false,
      showCancelCommitDocumentPower: false,
      showReplyDevDatePower: false,
      showHandleRejectPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)

    const rtnObjPromise = axiosHelper.handle('/WebAction/BaseData.User.GetUserSupply', {
    })
    const rtnObj = await rtnObjPromise
    if (rtnObj && rtnObj.error === '000000') {
      if (rtnObj.supplyRoleFlag === '0' && rtnObj.purchaseManagerRoleFlag === '0') {
        that.mainTable.customFilterStr = ''
      } else {
        let customFilterStr = " AND SupplyID IN (''"
        for (let i = 0; i < rtnObj.supplys.length; i++) {
          customFilterStr += ",'" + rtnObj.supplys[i].SupplyID + "'"
        }
        customFilterStr += ')'
        that.mainTable.customFilterStr = customFilterStr
      }
    }
    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.mainTable.detail1FilterStr = ''
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.itemNumber) {
        const itemNumbers = that.mainTable.itemNumber.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNumbers.length; i++) {
          detail1FilterStr += " OR ItemNumber LIKE'%" + itemNumbers[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.itemName) {
        const itemNames = that.mainTable.itemName.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNames.length; i++) {
          detail1FilterStr += " OR ItemName LIKE'%" + itemNames[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.Closed === '1' || data.row.Cancellation === 'True') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.Status === '3') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.Status === '2' || data.row.Status === '1') {
        if (data.row.DocumentCheckStatus === '1') {
          return { 'background-color': '#00FF7F' }
        } if (data.row.DocumentCommitStatus === '2') {
          return { 'background-color': '#FF4500' }
        } else if (data.row.DocumentCommitStatus === '1') {
          return { 'background-color': '#99ffff' }
        } else if (data.row.UploadDocumentStatus === '1') {
          return { 'background-color': 'orange' }
        }
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 展开行行样式设定方法
    mainTableDetail1RowStyle: function (row, ppoe) {
      if (row.Closed === '1' || row.Cancellation === 'True') {
        return { 'background-color': '#aaaaaa' }
      } else if (row.Status === '3' || ppoe.ErpClosed === '1') {
        return { 'background-color': '#cccccc' }
      }
    },

    // 上传材料弹出框显示方法
    showUploadDocumentDialogMD: function (scope) {
      const that = this
      that.uploadPPO = scope.data.row
      that.uploadTempFileUrl = ''
      that.uploadTempFileName = ''
      that.showUploadDocumentDialog = true
    },

    // 上传材料文件
    uploadDocumentFile: function (file) {
      const that = this
      const imgTest = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG|xlsx|xls|docx|dox|ppt|pptx|pdf)$/
      if (!imgTest.test(file.name)) {
        that.$message.warning('只能选择图片、Excel、Word、PPT、PDF类型的文件！')
        return false
      }
      if (file.size / 1024 / 1024 > 10) {
        that.$message.warning('文件大小不能超过10M！')
        return false
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const formData = new FormData()
      formData.append('file', file)
      axios({
        method: 'post',
        url: '/WebFileUpload/PurchaseManage.POOrder.UploadPOOrderDocumentFile',
        headers: {
          'Content-Type': 'multipart/form-data;charset=UTF-8'
        },
        data: formData
      }).then(function (response) {
        if (response.data && response.data.error === '000000') {
          that.uploadTempFileUrl = response.data.url
          that.uploadTempFileName = file.name
          loadingInstance.close()
          return true
        } else {
          that.$message.error('网络请求失败！')
          that.uploadTempFileUrl = ''
          that.uploadTempFileName = ''
          loadingInstance.close()
          return false
        }
      }).catch(function () {
        that.$message.error('网络请求失败！')
        that.uploadTempFileUrl = ''
        that.uploadTempFileName = ''
        loadingInstance.close()
        return false
      })
    },

    // 上传材料
    uploadDocument: async function () {
      const that = this
      if (!that.uploadTempFileUrl || !that.uploadTempFileUrl) {
        that.$message.error('请先选择材料文件！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.UploadPOOrderDocument', {
        ppo: that.uploadPPO,
        url: that.uploadTempFileUrl,
        fileName: that.uploadTempFileName
      })
      if (rtnObj.error === '000000') {
        that.showUploadDocumentDialog = false
        that.refreshMainTableContent()
        that.$message.success('上传成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 显示材料明细弹出框方法
    showPOOrderDocumentDialogMD: async function (row) {
      const that = this
      that.POOrderDocument = row.detailDt2
      that.showPOOrderDocumentDialog = true
    },

    // 删除材料
    deleteDocument: function (ppoDoc) {
      const that = this
      that.$confirm('此操作将永久删除该材料, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.DeletePOOrderDocument', {
          ppo: ppoDoc
        })
        if (rtnObj.error === '000000') {
          that.$message.success('删除成功！')
          that.refreshMainTableContent()
          that.showPOOrderDocumentDialog = false
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 材料提交
    commitPPO: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        if (that.mainTable.selections[i].UploadDocumentStatus !== '1') {
          that.$message.error('采购订单【' + that.mainTable.selections[i].BillNo + '】尚未上传材料，无法提交！')
          return
        }
        for (let j = 0; j < that.mainTable.selections[i].detailDt1.length; j++) {
          if (!that.mainTable.selections[i].detailDt1[j].NewDevDate) {
            that.$message.error('采购订单【' + that.mainTable.selections[i].BillNo + '】有交期未回复，无法提交！')
            return
          }
        }
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.CommitPOOrder', {
        ppos: that.mainTable.selections
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        if (rtnObj.msg.length <= 0) {
          that.$message.success('提交成功！')
        } else {
          that.$message({
            type: 'warning',
            message: '采购订单提交成功！，但是部分邮件发送失败！' + rtnObj.msg,
            duration: 0,
            showClose: true
          })
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 撤销材料提交
    cancelCommitPPO: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.CancelCommitPOOrder', {
        ppos: that.mainTable.selections
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('撤销提交成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 处理材料驳回
    handleRejectPPO: async function (row) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.CancelCommitPOOrder', {
        ppos: [row]
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('撤销提交成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 显示采购相关日志
    showPOOrderLogDialogMD: async function (scope) {
      const that = this
      that.POOrderLog = scope.data.row.detailDt3
      that.showPOOrderLogDialog = true
    },

    // 回复交期弹出框显示方法
    showReplyDevDateDialogMD: function (scope) {
      const that = this
      that.replyDevDatePPo = scope.data.row
      that.replyDevDateRows = scope.data.row.detailDt1
      that.replyDevDateRows.forEach(replyDevDateRow => {
        replyDevDateRow.NewDevDate = replyDevDateRow.NewDevDate ? replyDevDateRow.NewDevDate.substring(0, 10) : replyDevDateRow.DevDate.substring(0, 10)
      })
      that.showReplyDevDateDialog = true
    },

    // 获取回复交期弹出框表格高度
    getCreateReplyDevDateTableHeight: function () {
      return '300px'
    },

    // 回复交期弹出框表格单元格样式
    replyDevDateTableCellStyle: function () {
      return { padding: '0px' }
    },

    // 回复交期弹出框表格表头单元格样式
    replyDevDateTableHeaderCellStyle: function ({ column, columnIndex, row, rowIndex }) {
      if (column.property && (column.property === 'NewDevDate')) {
        return { color: 'blue', padding: '5px', 'background-color': '#f5f7fa' }
      } else {
        return { padding: '5px', 'background-color': '#f5f7fa' }
      }
    },

    // 回复交期弹出框回复交期变更方法
    replyDevDateTableNewDevDateChange: function (row) {
      const that = this
      if (row.NewDevDate) {
        try {
          row.NewDevDate = dateTimeUtil.formartDateTime(new Date(row.NewDevDate), 'yyyy-MM-dd')
          if (row.NewDevDate.length !== 10) {
            row.NewDevDate = ''
            that.$message.error('请输入正确格式的日期！（例如2020-01-01）')
          }
          that.$refs.replyDevDateTable.doLayout()
        } catch {
          that.$message.error('请输入正确格式的日期！（例如2020-01-01）')
        }
      }
    },

    // 回复交期弹出框保存提交方法
    saveNewDevDate: async function () {
      const that = this
      for (let i = 0; i < that.replyDevDateRows.length; i++) {
        if (!that.replyDevDateRows[i].NewDevDate) {
          that.$message.error('请输入回复交期！')
          return
        }
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.SaveReplyDevDate', {
        ppo: that.replyDevDatePPo,
        ppoes: that.replyDevDateRows
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('提交成功！')
        that.showReplyDevDateDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 打印采购订单
    printPOOrder: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }

      const rows = []
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        rows.push(that.mainTable.selections[i].InterID)
      }
      const dataJson = JSON.stringify(rows)
      window.open('/WebPrint/Print.Print.GetPOOrderPrintDataSet?poInterIDs=' + dataJson + '&reportName=POOrder.rpt')
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
  float: left;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
}
.tableInput {
  height: 26px;
  line-height: 26px;
  border: 0px #FFFFFF;
  background-color: transparent;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
</style>
